var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useMobileReport)?_c('company-report-mobile',{attrs:{"canteen":""}}):(_vm.useDesktopReport)?_c('company-report-desktop',{attrs:{"canteen":""}}):_c('canteen-report-legacy',{attrs:{"show-new-view":_vm.useLegacyDesktop},on:{"new-view":_vm.useNewView}})
}
var staticRenderFns = []

export { render, staticRenderFns }